"use client";

import { motion, useInView } from "framer-motion";
import Image from "next/image";
import { useRef } from "react";
import Button from "../Button";

export default function ProgramsSection() {
	const ref = useRef(null);
	const isInView = useInView(ref, { once: true, amount: 0.2 });

	return (
		<section ref={ref} className="py-16 md:py-24 bg-gray-50">
			<div className="container mx-auto px-4">
				<div className="grid grid-cols-1 lg:grid-cols-2 gap-5 lg:gap-0 items-center">
					<motion.div
						initial={{ opacity: 0, x: -30 }}
						animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: -30 }}
						transition={{ duration: 0.8, ease: "easeOut" }}
						className="relative h-[300px] md:h-[600px] rounded-2xl overflow-hidden"
					>
						<Image
							src="/assets/black/2.jpg"
							alt="Football program"
							fill
							className="object-cover"
						/>
					</motion.div>

					<motion.div
						initial={{ opacity: 0, x: 30 }}
						animate={isInView ? { opacity: 1, x: 0 } : { opacity: 0, x: 30 }}
						transition={{ duration: 0.8, delay: 0.2, ease: "easeOut" }}
						className="lg:-ml-24 relative z-20 bg-white lg:p-8 rounded-2xl shadow-lg"
					>
						<h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 leading-tight">
							Programs Designed To Unlock Your Full Potential
						</h2>

						<h3 className="text-primary text-sm md:text-base font-bold uppercase tracking-wide mb-2">
							Overview
						</h3>

						<div className="space-y-4 text-gray-600 leading-relaxed">
							<p>
								Reliance Future Football Academy (RFFA) is a premier youth
								athletic development institution dedicated to nurturing young
								football talents through a balanced combination of sports
								excellence and academic growth. At RFFA, we offer a structured
								youth training program focused on developing strength, speed,
								agility, tactical intelligence, and self-confidence...
							</p>
						</div>

						<div className="mt-8">
							<Button href="/programs" title="Learn more about our programs">
								Learn More
							</Button>
						</div>
					</motion.div>
				</div>
			</div>
		</section>
	);
}
